import React from 'react';
import {Button, ButtonGroup} from 'react-bootstrap';

const Row = ({ params, row, onAffidBtn }) => {
    const { hash, url, values } = row;
    const td = getValues(params, values);

    return <tr>
        {td}
        <td>
            <ButtonGroup>
                <Button bsStyle={'success'} onClick={() => onAffidBtn(hash)}>Affids</Button>
                <Button bsStyle={'info'} onClick={() => navigator.clipboard.writeText(url)}>URL</Button>
            </ButtonGroup>
        </td>
    </tr>;
};

function getValues(params, row) {
    return params.map((param, index) => {
        const value = row[index];

        if(param === 'icon' || param === 'image') {
            return(<td key={param}><img src={value} style={{ maxWidth: '200px'}}/></td>);
        }

        return(<td key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderSpy/components/Table/components/Row/index.js